import { ALTERAR_CRIANCA_COLO, BUSCAR_PEDIDO, SELECIONAR_PEDIDO } from '../../actions/types'

const initialState = undefined;

export default function reducerBuscarPedido (state = null, action = initialState) {
  switch (action.type) {
    case SELECIONAR_PEDIDO: {
      return action.payload;
    }

    case ALTERAR_CRIANCA_COLO: {
      const { reserva } = action.payload;
      const indiceReserva = state.reservas.indexOf(reserva);
      const novo = Object.assign({}, state);
      const novasReservas = [...novo.reservas]
      const novoPassageiro = Object.assign({}, reserva.passageiroDto, { criancaDto: reserva.passageiroDto.criancaDto ? null : {} });
      const novaReserva = Object.assign({}, reserva, { passageiroDto: novoPassageiro });
      novasReservas[indiceReserva] = novaReserva;
      novo.reservas = novasReservas;

      return novo
    }

    case BUSCAR_PEDIDO: {
      return action.payload.data;
    }

    default: {
      return state
    }
  }
}
